import { render } from "./Navbar.vue?vue&type=template&id=28dffb28&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=28dffb28&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Unimagem\\api_adm_unimagem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28dffb28"]])

export default __exports__